// extracted by mini-css-extract-plugin
export default {"conferenceMainText":"conference_conferenceMainText__I7K6Q","conferencePagination":"conference_conferencePagination__0d-Ce"};